function mobile_nav() {
    function toggle_menu_state() {
        $('#mobile_menu_trigger').toggleClass('open_menu')
        $('.navbox__inner').toggleClass('close_menu')
    }

    $('#mobile_menu_trigger').on('click', function () {
        toggle_menu_state();
    })

    $('.navbox__inner').on('click', function () {
        toggle_menu_state();
    })
}

export {
    mobile_nav
}